module.exports = require("@material/slider/dist/mdc.slider");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/slider/dist/mdc.slider","commonjs2":"@material/slider/dist/mdc.slider","commonjs":"@material/slider/dist/mdc.slider","amd":"@material/slider/dist/mdc.slider","umd":"@material/slider/dist/mdc.slider"}
// module id = 47
// module chunks = 0